import * as layout from '../../components/markLayout.module.css';
import React, { useMemo } from 'react';
import Table from '@hero/ui-kit/tables/Table';
import type { SegmentSummary } from '../../types';
import getSegmentColumns from './getSegmentColumns';
import usePagerProps from '../../../../hooks/usePagerProps';
type Props = {
    segments: SegmentSummary[];
    isLoading: boolean;
    pagerProps: ReturnType<typeof usePagerProps>;
    noDataMessage?: string;
};
const SegmentsList: React.FC<Props> = ({ segments, isLoading, pagerProps, noDataMessage }) => {
    const columns = useMemo(() => getSegmentColumns(), []);
    return (
        <div
            style={{
                overflowX: 'auto'
            }}
            className={layout.tableScroll}
        >
            <Table<SegmentSummary>
                columns={columns}
                data={segments}
                rowKey="segment_id"
                emptyValues="-"
                noDataMessage={noDataMessage}
                isLoading={isLoading}
                pagerProps={pagerProps}
            />
        </div>
    );
};
export default SegmentsList;
